<template>
  <div class="wrongbooklist" :class="{ active: userInfo }">
    <div v-if="!loaded" class="loaded-bg">
      <van-loading vertical>加载中...</van-loading>
    </div>
    <div v-else>
      <template>
        <div class="types">
          <div class="types-content">
            <div class="types-header">
              <div class="vipInfo">
                <div
                  class="vip_date"
                  :class="{ unactive: !book_vip }"
                  @click="toVip"
                  v-if="book_vip"
                >
                  <img
                    class="logo"
                    src="https://cdn-xcxcustom.weiyoubot.cn/20210701/35cc005f6f88f42cfc105dcca1e6634f.png"
                  />
                  <span v-if="book_vip && book_vip_end"
                    >{{ book_vip_end || "" }} 到期</span
                  >
                </div>
              </div>
              <div class="pointer" @click="toOrder()">历史订单</div>
            </div>
            <div class="total-count">
              <div>
                <div
                  class="total_wrong_count"
                  :class="{ unactive: !userInfo }"
                  @click="toastInfo"
                >
                  {{
                    userInfo
                      ? typelists[0].count +
                        typelists[1].count +
                        typelists[2].count +
                        typelists[3].count +
                        typelists[4].count
                      : "**"
                  }}
                </div>
                <!--  -->
              </div>
              <div>总错题数</div>
            </div>
            <div class="types-part">
              <div
                class="types-item"
                :class="{ unactive: !userInfo }"
                :data-type="item.type"
                :data-count="item.count"
                @click="typeTodo"
                v-for="item in typelists"
                :key="item.key"
              >
                <div class="count">{{ item.count }}</div>
                <div class="desc">{{ item.desc }}</div>
              </div>
            </div>
          </div>
          <div class="handle-btns">
            <div
              class="handle-item"
              :data-index="index"
              @click="handleAction(index)"
              v-for="(item, index) in handleList"
              :key="index"
            >
              <img :src="item.icon" class="handles-icon" />
              <div class="handle-desc">{{ item.title }}</div>
            </div>
          </div>
        </div>
        <div class="list-box">
          <div class="question" v-for="(a, index) in lists" :key="index">
            <div class="list-right">
              <q-item
                :book_vip="book_vip"
                :a="a"
                :show_answer="a.show_answer"
                :pagesize="count"
                :index="index"
                :page="page"
                :is_my_result="1"
                :wrongbook="1"
                :hide_score="a.hide_score"
                @handleWrongClick="handleWrongClick"
                :copy_able="0"
              />
            </div>
          </div>
        </div>
        <template
          v-if="
            lists &&
              lists.length &&
              total_wrong_count &&
              !book_vip &&
              total_wrong_count > 3
          "
        >
          <div>
            <div class="welfare" @click="toBuyFooter">
              <div class="left">
                <div class="left-vip">
                  <img
                    class="left-icon"
                    src="https://cdn-xcxcustom.weiyoubot.cn/20210701/35cc005f6f88f42cfc105dcca1e6634f.png"
                  />
                  查看/练习全部错题
                </div>
                <div class="vip-desc">
                  默认展示前{{ count }}题，开通后可查看全部
                </div>
              </div>
              <div class="welfare-right">
                立即前往<img
                  src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220729/787a041ab28350c97a8b6577e1fcf3a1.png"
                  class="welfare-right-icon"
                />
              </div>
            </div>
          </div>
        </template>
        <div v-if="userInfo" class="footer" @click="toBuyFooter">
          <div class="btn">错题重练</div>
        </div>
        <div v-if="!userInfo" class="login-box">
          <div class="login-desc">点击登录看错题</div>
          <button class="login-btn" @click="loginClick">立即登录</button>
        </div>
      </template>
      <template v-if="showScan">
        <scan-code
          src="https://cdn-xcx-qunsou.weiyoubot.cn/material/2023-01-04/835fdbe5ba8e7fdb70d95ea5ede9a0ee.png"
          @hideVisible="handleScanCode"
        ></scan-code>
      </template>
      <confirmDialog
        :confirmContent="confirmContent"
        @confirmClick="confirmClick"
        @hideConfirm="hideConfirm"
        :visible="confirmVisible"
      />
    </div>
    <template v-if="showLogin">
      <ScanLogin
        @hideVisible="handleScan()"
        :type="qrcodeType"
        :targetIndex="productIndex"
        :src="loginQrcode"
        :productList="productList"
        :payType="payType"
      />
    </template>
  </div>
</template>
<script>
import questionOnly from "@/utils/questionOnly";
import {
  jumpWxAuth,
  getToken,
  formatDateTime,
  isMobile,
  isWeixin,
  verifyAuth,
  getWxUrl,
  showServiceAble,
  getQueryString,
  handleCode,
  formatDate,
  filterPunctuation,
  trim,
  wrongbookClick
} from "@/utils/common";
import api from "@/utils/api";
import { Toast, Dialog } from "vant";
import ContactImg from "@/components/contactImg";
import RightCode from "../../components/rightCode.vue";
import ScanLogin from "@/components/scanLogin";
import ScanCode from "@/components/scanCode.vue";
import GzhFile from "../../components/gzhfile.vue";
import confirmDialog from "../../components/confirmDialog.vue";
import GetPhone from "../../components/getphone.vue";
import qItem from "../../components/common/qItem.vue";
import { handleZI } from "../../utils/common";

let checkTime = 0;
let intervalAsk;
export default {
  data() {
    return {
      from_type: '',
      confirmContent: [],
      confirmVisible: false,
      loaded: false,
      userInfo: false,
      total_wrong_count: 5,
      book_vip: 0,
      page: 1,
      count: 20,
      min_count: 3,
      lists: [],
      payType: 1,
      showScan: false,
      showLogin: false,
      loginQrcode: "",
      qrcodeType: 0,
      showRightCode: false,
      isWeixin: isWeixin(),
      isMobile: isMobile(),
      showContact: false,
      buyInfo: "",
      showModal: false,
      path: "/pages/wrongbook/wrongbooklist/wrongbooklist",
      name: "立吉答题用户",
      avatar: "",
      book_vip: 0,
      book_vip_start: "",
      book_vip_end: "",
      productIndex: 1,
      b_time: "",
      productList: [],
      hasUserInfo: false,
      typelists: [
        {
          count: "**",
          desc: "单选题",
          key: 1,
          type: 0
        },
        {
          count: "**",
          desc: "多选题",
          key: 2,
          type: 1
        },
        {
          count: "**",
          desc: "判断题",
          key: 3,
          type: 2
        },
        {
          count: "**",
          desc: "填空题",
          key: 4,
          type: 3
        },
        {
          count: "**",
          desc: "图片题",
          key: 5,
          type: 5
        }
      ],
      handleList: [
        {
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-03-04/516fbbf79ed741a951f0b34aacadbb05.svg",
          title: "批量管理"
        },
        {
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-03-04/68908310b770cac9c40783f35735a1ab.svg",
          title: "导出PDF"
        },
        {
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-03-04/0a6a4a99a7f56f043e34b773fef60a20.svg",
          title: "导入错题"
        },
        {
          icon:
            "https://cdn-xcx-qunsou.weiyoubot.cn/material/2024-03-04/a99c3829c7aa1affdf0b2ce12e35c08f.svg",
          title: "错题重练"
        }
      ]
    };
  },
  components: {
    [Toast.name]: Toast,
    [Dialog.name]: Dialog,
    ContactImg,
    RightCode,
    ScanLogin,
    ScanCode,
    GetPhone,
    GzhFile,
    confirmDialog,
    qItem
  },

  methods: {
    toOrder() {
      if (!this.userInfo) return this.loginClick();
      this.$router.push({
        name: "orderlist"
      });
    },
    loginClick() {
      if (this.isWeixin) {
        jumpWxAuth();
      } else {
        if (!this.isMobile) {
          this.getLoginCode();
        } else {
          this.getWxSchema(1);
        }
      }
    },
    confirmClick(type) {
      if (type == "cancel") {
        this.hideConfirm();
      } else {
        wrongbookClick(this.confirmType, this.confirmTypeName, 1);
        this.hideConfirm();
        this.toBuy();
      }
    },
    hideConfirm() {
      this.confirmVisible = false;
    },
    toVip() {
      if(this.from_type == 1) {
        this.getWxSchema(1, true);
      }else {
        this.$router.push({ name: "serviceBuy" });
      }
    },
    toBuyFooter() {
      if (this.book_vip) {
        return this.getWxSchema(1, true);
      }
      wrongbookClick("bottom_lead", "底部引导-查看全部错题", 1);
      if(this.from_type == 1) {
        this.getWxSchema(1, true);
      }else {
        this.$router.push({ name: "serviceBuy" });
      }
    },
    handleAction(index) {
      if (!this.userInfo) return this.loginClick();
      if (this.book_vip) {
        return this.getWxSchema(1, true);
      }
      if (index == 0) {
        this.confirmContent = [
          "开通错题本后才可使用「批量管理」功能以及其他错题本功能"
        ];
        this.confirmType = "batch_manage";
        this.confirmTypeName = "批量管理";
        this.confirmVisible = true;
      } else if (index == 1) {
        this.confirmContent = [
          "开通错题本后才可使用「导出PDF」功能以及其他错题本功能"
        ];
        this.confirmType = "export";
        this.confirmTypeName = "导出题目";
        this.confirmVisible = true;
      } else if (index == 2) {
        this.confirmContent = [
          "开通错题本后才可使用「导入错题」功能以及其他错题本功能"
        ];
        this.confirmType = "add_book";
        this.confirmTypeName = "添加错题";
        this.confirmVisible = true;
      } else if (index == 3) {
        wrongbookClick("bottom_lead", "底部引导-查看全部错题", 1);
        this.toBuy();
      }
    },
    toBuy() {
      if(this.from_type == 1) {
        this.getWxSchema(1, true);
      }else {
        this.$router.push({ name: "serviceBuy" });
      }
    },
    typeTodo() {
      if (!this.userInfo) return this.loginClick();
      if (this.book_vip) {
        return this.getWxSchema(1, true);
      }
      if(this.from_type == 1) {
        this.getWxSchema(1, true);
      }else {
        this.$router.push({ name: "serviceBuy" });
      }
    },
    toastInfo() {
      Dialog.alert({
        title: "错题本",
        message:
          "1.只有出题人开启【允许加入错题本】时，作答后产生的错题才会自动加入错题本；\n2.若出题人设置不展示答案与解析，加入错题本后也不会展示；\n3.支持自行收集错题上传，生成自己专属的错题本；\n4.删除错题后无法恢复;",
        confirmButtonColor: "#1890ff"
      });
    },
    //获取用户信息
    handleUserInfo() {
      let param = { access_token: getToken() };
      questionOnly.get(api.question.getBookDetail, param).then(res => {
        if (res.sta == 0) {
          let { book_vip } = res.data;
          (this.count = book_vip ? this.count : this.min_count),
            (this.loaded = true);
          this.userInfo = true;
          if (book_vip) {
            // 已经购买了错题本权限跳转至小程序错题本列表页
            this.getWxSchema(1, true);
          }
          this.getList();
        } else if (res.sta == -500) {
          jumpWxAuth();
        }
      });
    },

    getList() {
      let param = { access_token: getToken(), count: this.count };
      questionOnly.get(api.question.getWrongbookList, param).then(res => {
        if (res.sta == 0) {
          let {
            lists,
            single_wrong_count,
            multi_wrong_count,
            judge_wrong_count,
            blank_wrong_count,
            total_wrong_count,
            book_vip,
            book_vip_end,
            pic_wrong_count
          } = res.data;
          let typelists = this.typelists;
          typelists[0].count = single_wrong_count;
          typelists[1].count = multi_wrong_count;
          typelists[2].count = judge_wrong_count;
          typelists[3].count = blank_wrong_count;
          typelists[4].count = pic_wrong_count;
          this.book_vip = book_vip;
          this.typelists = typelists;
          this.loaded = true;
          this.book_vip_end = book_vip_end;
          (this.book_vip_end = book_vip_end
            ? formatDate(new Date(book_vip_end * 1000), "yyyy-MM-dd")
            : ""),
            (this.total_wrong_count = total_wrong_count);
          this.userInfo = true;
          this.transLists(lists);
        } else if (res.sta == -500) {
          jumpWxAuth();
        }
      });
    },
    transLists(lists) {
      lists.map((n, i) => {
        n.score_get = n["score_get"] || 0;
        let _score = n.score;
        n.right = _score == n.score_get ? 1 : 0;
        if (n.type == 4) n.right = n.score_get == -1 ? 1 : n.right;
        let c = "";
        if (n.options && n.options.length > 0) {
          // return;
          n.options.map((m, j) => {
            if (n.type == 3) {
              // 填空每个空的分……
              let temp_input =
                n["opt"] && n["opt"][j] ? filterPunctuation(n["opt"][j]) : "";
              // 判断填空是否未作答
              let len = n.opt && n.opt.filter(item => item != "").length;
              if (len) {
                n.optEmpty = false;
              } else {
                n.optEmpty = true;
              }
              let temp_m = [];
              m.blank &&
                m.blank.map(item => {
                  item = trim(item);
                  temp_m.push(filterPunctuation(item));
                });
              if (temp_m.indexOf(trim(temp_input)) == -1) m.right = 0;
              else m.right = 1;
            } else {
              // 选择题
              m.check = 0;
              m.letter = String.fromCharCode(64 + parseInt(j + 1));
              if (n["opt"] && n["opt"].indexOf(j) != -1) m.check = 1;
              if (m.right == 1) c += m.letter;
            }
          });
          n.correct = c;
        }
        n.your_answer = "";
        if (n.type == 3) {
          n.your_answer = n["opt"] ? n["opt"].toString() : "";
        } else {
          let opt = n["opt"];
          for (const i in opt) {
            let _letter = String.fromCharCode(64 + parseInt(opt[i]) + 1);
            n.your_answer += _letter;
          }
        }
        n.join_time = formatDate(new Date(n.t_add * 1000), "yyyy-MM-dd HH:mm");
        // 判读视频是否违规
        if (
          n.videos &&
          n.videos.length &&
          n.videos[0].url.indexOf("mp4") > -1
        ) {
          n.videoAble = true;
        }
        if (n.type == 0 || n.type == 1 || n.type == 2) {
          let correct = [];
          for (const j in n.options) {
            if (n.options[j].right == 1) correct.push(n.options[j].letter);
          }
          n.correct = correct.join("");
        }
      });
      this.lists = lists;
    },
    contactService() {
      this.handleContact();
    },
    handleWrongClick() {
      this.getWxSchema(1, true)
    },
    async getWxSchema(type, replace) {
      if (this.isMobile) {
        let path = "pages/wrongbook/wrongbooklist/wrongbooklist";
        let url = await getWxUrl(path, type ? "" : 1, 1);
        if (url) {
          if (replace) {
            window.location.replace(url);
            history.replaceState(null, document.title, url);
          } else {
            window.location.href = url;
          }
        }
      } else {
        this.showModal = false;
        this.handleScanCode();
      }
    },
    getLoginCode() {
      var timestamp = new Date().getTime();
      var myToken =
        timestamp + Math.ceil(Math.random() * 1000000000000000) + "";
      // 获取二维码  开始轮询请求，如果返回ok，清除轮询
      questionOnly
        .get("/xcx/ques_web/v1/qrcode", { token: myToken })
        .then(res => {
          if (res.sta == 0) {
            this.loginQrcode = res.data.qrcode;
            this.qrcodeType = 0;
            if (!this.showLogin) this.showLogin = true;
            checkTime = 0;
            this.checkLoginSuccess(myToken);
          } else {
            Toast(res.msg || "请求失败");
          }
        });
    },
    getPayCode() {
      questionOnly
        .post("/xcx/ques/v1/order", {
          access_token: getToken(),
          type: "wrong_book_v2",
          duration: this.productList[this.productIndex].days,
          pay_source: 1 // 付费来源 1:h5, 2:pc, 3:腾讯会议, 默认为1
        })
        .then(res => {
          if (res.sta == 0) {
            this.loginQrcode = res.data.qrcode;
            this.qrcodeType = 1;
            this.showLogin = true;
            checkTime = 0;
            this.checkPaySuccess(res.data.order_id);
          } else {
            Toast(res.msg || "请求失败");
          }
        });
    },
    checkLoginSuccess(myToken) {
      clearTimeout(intervalAsk);
      checkTime++;
      if (checkTime > 20) {
        checkTime = 0;
        this.getLoginCode();
        return;
      }
      questionOnly
        .get("/xcx/ques_web/v1/check_status", {
          token: myToken,
          loadingMsg: "no"
        })
        .then(res => {
          if (res.sta === -1) {
            intervalAsk = setTimeout(() => {
              this.checkLoginSuccess(myToken);
            }, 3000);
          } else {
            // 登录成功
            localStorage.setItem("token", res.data.access_token);
            handleZI(res.data.mp_openid)
            setTimeout(() => {
              this.showLogin = false;
              this.handleUserInfo();
            }, 100);
          }
        });
    },
    handleScanCode() {
      this.showScan = !this.showScan;
    },
    handleScan() {
      if (intervalAsk) {
        clearInterval(intervalAsk);
        intervalAsk = null;
      }
      this.showLogin = !this.showLogin;
    },
    async handleContact() {
      let res = await showServiceAble();
      if (res) {
        this.showContact = !this.showContact;
      }
    },
    showPanel() {
      this.showContact = true;
    },
    closeConfirm() {
      this.showModal = false;
    },
    handleLaunchFn() {},
    handleErrorFn() {}
  },
  async mounted() {
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
    this.from_type = getQueryString("from_type") || '';
    if (getQueryString("ut")) {
      localStorage.setItem("token", getQueryString("ut"));
      this.handleUserInfo();
      return;
    }
    let loginStatus = await verifyAuth();
    if (loginStatus) {
      this.handleUserInfo();
    } else {
      if (this.isWeixin) {
        if (getToken()) {
          jumpWxAuth();
        } else {
          if (!getToken() && getQueryString("code")) {
            let res = await handleCode(getQueryString("code"));
            if (res) {
              this.handleUserInfo();
              return;
              // let arr = document.location.toString().split("&code=")[0];
              // window.location.replace(arr);
            }
            return;
          } else {
            this.loaded = true;
          }
        }
      } else {
        this.loaded = true;
        if (!this.isMobile) {
          // pc
          this.getLoginCode();
        }
      }
    }
  },
  destroyed() {
    if (intervalAsk) {
      clearInterval(intervalAsk);
      intervalAsk = null;
    }
  }
};
</script>

<style scoped lang="scss">
.wrongbooklist {
  // background: #ffffff;
  max-width: 500px;
  min-width: 320px;
  position: relative;
  min-height: 100vh;
  margin: 0 auto;
}
.wrongbooklist.active {
  padding-bottom: 75px;
}

.types {
  padding: 30px 0 10px;
  position: relative;
  box-sizing: border-box;
  height: 315px;
  background: linear-gradient(180deg, #138cff 0%, rgba(255, 255, 255, 0) 100%);
}

.types-content {
  background: #ffffff;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  height: 175px;
  top: 30px;
  left: 15px;
  right: 15px;
  padding: 16px 17px;
  box-sizing: border-box;
  margin: 0 15px;
}

.types-header {
  color: #999999;
  font-size: 12px;
  height: 15px;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.vipInfo {
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex: 1;
}

.vipInfo.active {
  justify-content: flex-end;
}

.vip_date {
  display: flex;
  align-items: center;
}

.types-header .logo {
  width: 14px;
  height: 14rpx;
  margin-right: 7px;
}

.types-header .ask {
  width: 15px;
  height: 15px;
}

.total-count {
  text-align: center;
  margin-top: 10px;
  font-size: 12px;
  line-height: 18px;
  color: #999999;
}

.total-count div:first-child {
  font-weight: 800;
  font-size: 21px;
  line-height: 31px;
  color: #262626;
}

.types-part {
  margin-top: 20px;
  display: flex;
}

.types .types-item {
  flex: 1;
  position: relative;
  text-align: center;
  cursor: pointer;
}
.types-item.unactive {
  color: #999999;
}
/* .types .types-item:first-child{
  width: 181rpx;
} */
.types .types-item .count {
  font-size: 16px;
  line-height: 24px;
}

.types .types-item .desc {
  color: #999999;
  font-size: 13px;
  line-height: 18px;
  padding: 0;
}

.types .types-item:after {
  content: "";
  position: absolute;
  width: 1px;
  background: #eeeeee;
  height: 20px;
  right: 0;
  top: 13px;
  z-index: 3;
}

.types .types-item:last-child:after {
  height: 0;
}

.total_wrong_count {
  display: inline-block;
  position: relative;
}
.total_wrong_count.unactive {
  color: #999999 !important;
}

.total_wrong_count:after {
  position: absolute;
  content: "";
  top: 0;
  width: 18px;
  height: 18px;
  background: url("https://cdn-xcx-qunsou.weiyoubot.cn/material/20220316/a88cb4790c49d6b5b8de174f7ed19d79.svg");
  background-size: 100%;
  right: -20px;
}

.total_wrong_count img {
  position: absolute;
  width: 15px;
  height: 15px;
  right: -20px;
}

.handle-btns {
  display: flex;
  justify-content: center;
  height: 90px;
  border-radius: 5px;
  background: #ffffff;
  box-sizing: border-box;
  margin: 10px 15px 0;
  padding-top: 19px;
}

.handle-item {
  text-align: center;
  flex: 1;
  font-size: 14px;
  line-height: 16px;
  cursor: pointer;
}

.handles-icon {
  width: 25px;
  height: 25px;
  margin-bottom: 10px;
}
.list-box {
  margin: 0 15px 0;
  // line-height: 1.4;
}

.question {
  padding: 15px;
  display: flex;
  align-items: flex-start;
  margin-bottom: 10px;
  background: #ffffff;
  border-radius: 5px;
}

.question .list-left {
  width: 22px;
  margin-right: 10px;
  position: relative;
}

.question .list-left image {
  width: 22px;
  height: 22px;
}

.question .list-right {
  flex: 1;
}

.question .list-right .options {
  padding-top: 20px;
}

.desc {
  /* padding-bottom: 20px; */
  font-size: 15px;
}

.discussion image {
  width: 345px;
  margin-top: 5px;
}

.option {
  display: flex;
  display: -webkit-flex;
  font-size: 15px;
  align-items: center;
  margin-bottom: 15px;
}

.option:last-child {
  margin-bottom: 0;
}

.option img,
.letter {
  width: 15px;
  height: 15px;
  min-width: 15px;
  margin-right: 10px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
}

.option .view {
  flex: 1;
}

.grey {
  color: #999;
  padding-right: 5px;
}

view.grey {
  padding-top: 5px;
}

.answer {
  font-size: 14px;
  padding-top: 15px;
}

.answer:last-child {
  padding-top: 20px;
  padding-bottom: 20px;
}

.analysis {
  margin-bottom: 5px;
}
.analysis-text {
  font-size: 15px;
}

.mb10 {
  margin-top: 5px;
}
.info-box {
  background: #fff;
  padding: 0 15px;
  margin-bottom: 10px;
}

.info-box .top {
  border-bottom: 0.5px solid #eee;
  font-size: 15px;
  padding: 15px 0;
}

.info-box .bottom {
  font-size: 14px;
  padding: 12px 0;
  line-height: 1.8;
}

.blank-text {
  padding-right: 10px;
}

.row-box {
  display: flex;
  align-items: center;
  padding-top: 5px;
}

.grey {
  color: #999;
  padding-right: 5px;
}

.grey.active {
  color: #ff0000;
}

view.grey {
  padding-top: 5px;
}

.answer .grey {
  font-size: 14px;
  line-height: 21px;
}

.infos {
  background: #f8f8f8;
  padding: 10px;
  font-size: 14px;
  line-height: 21px;
  color: #666666;
  margin-top: 10px;
}

.infos .infos-item:first-child {
  margin-bottom: 5px;
}

.handle-btn {
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
}

.handle-btn .remove {
  width: 95px;
  text-align: center;
  height: 30px;
  line-height: 30px;
  border-radius: 2px;
  color: #fff;
  background: #ff7070;
  font-size: 15px;
}

.handle-btn .edit {
  width: 50px;
  height: 30px;
  line-height: 30px;
  text-align: center;
  background: #1890ff;
  font-size: 15px;
  color: #fff;
  margin-left: 20px;
  border-radius: 2px;
}
.quesItem-header {
  margin-bottom: 11px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.quesItem-type {
  height: 20px;
  line-height: 20px;
  padding: 0 6px;
  font-size: 12px;
  background: rgba(24, 144, 255, 0.1);
  border-radius: 10px;
  color: #1890ff;
}

.quesItem-type .left {
  position: relative;
  font-size: 12px;
  color: #1890ff;
}
.gray {
  color: #999999;
  font-size: 14px !important;
}
.footer {
  position: fixed;
  left: auto;
  bottom: 0;
  background: #ffffff;
  margin-top: 20px;
  height: 1;
  max-width: 500px;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #ffffff;
  border-top: 1px solid #eee;
  width: 100%;
  box-sizing: border-box;
  z-index: 9;
}
.footer .btn {
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 25px;
  background: #1890ff;
  font-size: 17px;
  color: #fff;
  margin: 0 15px 0;
  flex: 1;
}
.welfare {
  background-size: cover;
  padding: 18px 15px;
  box-sizing: border-box;
  color: #ffffff;
  border-radius: 4px;
  margin: 0 auto;
  background: #313238;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 5px 15px 30px;
}

.welfare-box {
  background: #fff;
}

.welfare .left-vip {
  display: flex;
  align-items: center;
  font-weight: bold;
  font-size: 15px;
  line-height: 17px;
  margin-bottom: 5px;
}

.vip-desc {
  font-size: 12px;
  line-height: 15px;
  line-height: 12px;
}

.welfare .left-icon {
  width: 19px;
  height: 19px;
  margin-right: 5px;
}

.welfare-right {
  background: linear-gradient(90deg, #d8ae7a -9.8%, #f5cea5 100%);
  border-radius: 150px;
  text-align: center;
  line-height: 22px;
  font-size: 14px;
  color: #313238;
  padding: 2px 10px;
  display: inline-flex;
  align-items: center;
}

.welfare-right-icon {
  width: 7px;
  height: 12px;
  margin-left: 5px;
}
.loaded-bg {
  min-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.handle-icon {
  width: 18px;
  height: 18px;
  margin-left: 15px;
  cursor: pointer;
}

.answer .green {
  color: #00cf97;
}

.answer .red {
  color: #ff5c5c;
}

.fillBlank-single {
  line-height: 25px;
}

.fillBlank > div {
  margin-bottom: 10px;
}

.fillBlank > div:last-child {
  margin-bottom: 0;
}
.pics,
.videos {
  margin: 5px 0 15px;
}
.videos-item {
  width: 100%;
}

.pics-items {
  object-fit: cover;
  width: 100%;
}
.login-box {
  margin-top: 60px;
}
.login-box {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.login-desc {
  font-size: 15px;
  line-height: 25px;
  color: #999999;
  margin-bottom: 15px;
}
.login-btn {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0px;
  background: #1890ff;
  width: 150px;
  height: 42px;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  font-size: 17px;
}
</style>



// WEBPACK FOOTER //
// src/pages/wrongbook/wrongbooklist.vue